import SummaryTables from 'src/components/SummaryTables';
import SummaryLine from 'src/components/SummaryLine';
import SummaryCard from 'src/components/SummaryCard';
import { Grid } from '@mui/material';

const ReviewDifference = ({ values }) => {
  const createOriginalSummaryContent = () =>
    values.map(({ label, original }, index) => {
      return Array.isArray(original) === true ? (
        <SummaryTables label={label} values={original} key={index} />
      ) : (
        <SummaryLine label={label} value={original} key={index} />
      );
    });

  const createUpdateSummaryContent = () =>
    values.map(({ label, updated }, index) => {
      return Array.isArray(updated) === true ? (
        <SummaryTables label={label} values={updated} key={index} />
      ) : (
        <SummaryLine label={label} value={updated} key={index} />
      );
    });

  return (
    <Grid container spacing={2}>
      <SummaryCard title="Original" summaryContent={createOriginalSummaryContent()} />
      <SummaryCard title="Updated" summaryContent={createUpdateSummaryContent()} />
    </Grid>
  );
};

export default ReviewDifference;
